import { TabGroupModel } from "../models/tabGroupModel";
import { TabModel } from "../models/tabModel";
import { AppState } from "../reducers/rootReducer";

export const getTabs = (state: AppState) => state.tabList;
export const getTabsByElementId = (elementId: String) => (state: AppState) => { return state.tabList.filter((tab) => tab.elementId === elementId) };
export const getCollapseByElementId = (elementId: String) => (state: AppState) => { return state.tabList.filter((tab) => tab.elementId === elementId) };
export const getTabPanelByTab = (tabId: String) => (state: AppState) => { return state.rowList.filter((row) => { if (row.type === 'Tab' && row.tabId === tabId) return row }) };
export const getMainTabsByElementId = (elementId: String) => (state: AppState) => {
    return state.tabList.filter((tab) => { if (tab.elementId === elementId && tab.isMain) return tab });
};
export const getSubTabListByTab = (tab: TabModel) => (state: AppState) => {
    return state.tabList.filter((tabItem) => { if (tabItem.elementId === tab.elementId && tabItem.pairedKey === tab.pairedKey && !tabItem.isMain) return tab });
}
export const getTabListbyElementId = (elementId: String, isPreview: boolean) => (state: AppState) => {
    let tabList = state.tabList.filter((tab) => { return tab.elementId === elementId });
    let pairedKeyList: string[] = []
    let pairedGroupList = [];
    for (let i = 0; i < tabList.length; i++) {
        const element = tabList[i];
        if (element.isMain) {
            if (element.isDropDownTab) {
                pairedKeyList.push(element.pairedKey)
            }
            else {
                if (isPreview) {
                    if (element.display) {
                        let pairedTabList: TabGroupModel = { tabList: [], index: 0 };
                        pairedTabList.index = i;
                        pairedTabList.tabList.push(element);
                        pairedGroupList.push(pairedTabList);
                    }
                } else {
                    let pairedTabList: TabGroupModel = { tabList: [], index: 0 };
                    pairedTabList.index = i;
                    pairedTabList.tabList.push(element);
                    pairedGroupList.push(pairedTabList);
                }
            }
        }
    }

    for (let index = 0; index < pairedKeyList.length; index++) {
        let pairedTabList: TabGroupModel = { tabList: [], index: 0 }
        for (let i = 0; i < tabList.length; i++) {
            const element = tabList[i];
            if (element.pairedKey === pairedKeyList[index]) {
                if (element.isMain) pairedTabList.index = i;
                pairedTabList.tabList.push(element);
            }
        }
        pairedGroupList.push(pairedTabList);
    }

    pairedGroupList.sort((a, b) => a.index - b.index);

    return pairedGroupList;

}